import getApi from '../../api'

export const deletePrescriptionTemplate = (id: string) =>
  getApi().delete<void>(`prescription_templates/${id}`)
